import * as actionTypes from "./constants";
import moment from "moment";

const removeTime = date => {
  if (date) date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  return date;
};

const initalState = {
  dateFrom: removeTime(moment.utc()),
  dateTo: removeTime(moment.utc()),
  focusedInput: undefined
};

export default (state = initalState, action) => {
  switch (action.type) {
    case actionTypes.SET_DATES:
      return {
        ...state,
        dateFrom: removeTime(action.dateFrom),
        dateTo: removeTime(action.dateTo)
      };
    case actionTypes.SET_FOCUSED_INPUT:
      return {
        ...state,
        focusedInput: action.input
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/cleaning/schedule/dateRangePicker/reducer.js